export enum SolutionClasses {
  ACTIVE_UNIT = "ACTIVE_UNIT",
  DISCHARGE_PLANNING = "DISCHARGE_PLANNING", // QCard w/intelligence
  DISCHARGE_SUPPORT = "DISCHARGE_SUPPORT", // QCard w/o intelligence
  OBSERVATION_SUPPORT = "OBSERVATION_SUPPORT", // QCard w/o intelligence
  OBSERVATION_PLANNING = "OBSERVATION_PLANNING", // QCard w/o intelligence
  CAPACITY_SUPPORT = "CAPACITY_SUPPORT",
  CARE_GAPS_AUTOMATION = "CARE_GAPS_AUTOMATION", // Malnutrition application
  UNKNOWN = "UNKNOWN",
}
